import {
  HELP_OVERLAY_URL,
  PRODUCT,
  APPLICATION,
  SECONDARY_PRODUCT,
  MAGNOLIA_NEXT_API_URL,
  INT_COUNTRY,
} from "@/constants";

const fetchHelpOverlay = async (
  risk: "lowRisk" | "mediumRisk" | "highRisk" | "veryHighRisk"
) => {
  let pageJson;

  try {
    let fetchURL = "";
    if (APPLICATION === "renewal") {
      fetchURL = `${MAGNOLIA_NEXT_API_URL}/${HELP_OVERLAY_URL}/${PRODUCT}-${APPLICATION}/${risk}`;
    } else {
      fetchURL = `${MAGNOLIA_NEXT_API_URL}/${HELP_OVERLAY_URL}/${
        INT_COUNTRY ?? SECONDARY_PRODUCT ?? PRODUCT
      }/${risk}`;
    }
    const response = await fetch(fetchURL);

    if (!response.ok) {
      pageJson = {};
    }

    const res = await response.json();
    pageJson = res.data;
  } catch (error: unknown) {
    // Network failure, timeout, invalid JSON, etc.
    // eslint-disable-next-line no-console
    console.log("Error fetching help overlay:", error);
    pageJson = {};
  }

  return pageJson;
};

export default fetchHelpOverlay;
